(function () {
    const originalFetch = window.fetch;

    window.fetch = async function (url, options = {}) {
        const urlString = typeof url === "string" ? url : url.toString();

        // ADD: collega rete e piedi con _bundle_id
        if (urlString.includes("/cart/add") && options.body instanceof FormData) {
            var ids = options.body.getAll("id[]");
            if (ids.length > 1) {
                var mainId = (options.body.get("sections_url") || "").split("variants/").pop().split(/[?#]/)[0];
                var bid = String(Date.now());
                var items = ids.map(function (id) {
                    return {
                        id: parseInt(id),
                        quantity: 1,
                        properties:
                            String(id) === mainId ? { _bundle_id: bid } : { _bundle_id: bid, _is_accessory: "1" },
                    };
                });
                options = {
                    ...options,
                    body: JSON.stringify({
                        items: items,
                        sections: options.body.get("sections"),
                        sections_url: options.body.get("sections_url"),
                    }),
                    headers: { ...options.headers, "Content-Type": "application/json", Accept: "application/json" },
                };
            }
        }

        // REMOVE: quando rimuovi la rete, rimuovi prima i piedi collegati
        if (urlString.includes("/cart/change") && options.body) {
            var p;
            try {
                p = typeof options.body === "string" ? JSON.parse(options.body) : null;
            } catch (e) {}
            if (p && String(p.quantity) === "0") {
                var cart = await (await originalFetch("/cart.js")).json();
                var removed = cart.items.find(function (i) {
                    return i.key === p.id;
                });
                if (
                    removed &&
                    removed.properties &&
                    removed.properties._bundle_id &&
                    !removed.properties._is_accessory
                ) {
                    var acc = cart.items.filter(function (i) {
                        return (
                            i.properties &&
                            i.properties._bundle_id === removed.properties._bundle_id &&
                            i.properties._is_accessory
                        );
                    });
                    for (var i = 0; i < acc.length; i++) {
                        await originalFetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ id: acc[i].key, quantity: 0 }),
                        });
                    }
                }
            }
        }

        return originalFetch.call(window, url, options);
    };

    // CART PAGE: il tema usa window.location.href invece di fetch per rimuovere,
    // quindi l'interceptor sopra non scatta. Intercettiamo il click in capture phase
    // prima che LineItemQuantity faccia la navigazione diretta.
    if (window.themeVariables && window.themeVariables.settings.pageType === "cart") {
        document.addEventListener(
            "click",
            function (e) {
                var link = e.target.closest('a[href*="/cart/change"]');
                if (!link) return;

                var linkUrl = new URL(link.href);
                var quantity = linkUrl.searchParams.get("quantity");
                if (quantity !== "0") return;

                e.preventDefault();
                e.stopPropagation();

                var lineKey = linkUrl.searchParams.get("id");

                // Usa window.fetch (wrappato) così l'interceptor REMOVE scatta
                window
                    .fetch("/cart/change.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: lineKey, quantity: 0 }),
                    })
                    .then(function () {
                        window.location.reload();
                    });
            },
            true
        );
    }
})();
